module.exports = {

	defaultLanguage: 'pt-BR',
	activePromotion: 'weekly3d',
	subscribeRequestContext: {
		expiresIn: '1h',
		secret: 'SgtPepper'
	},

	yellowBarCorrectAnswerTime: 5000,
	secureTransitionPageTime: 100,
	homeScrollToFormTime: 500,
	nextLottery: {
		WEEKLY: "00/00/0000",
		MONTHLY: "14/09/2019",
		TRIMESTRIAL: "00/00/0000",
	},
	ticketSize: {
		WEEKLY: "0000000",
		MONTHLY: "0000000",
		TRIMESTRIAL: "0000000",
	},
	ticketPaginationCount: 5,

	pointsToGainTicket: 3,

	bodyContainerId: "main-container",

	countryConfig: {
		countryPrefix: '55',
		masks: {
			phoneNumber: '(99) 99999-9999'
		}
	},

	validateCodeSize: 4,

	path: '/',
	imgPath: '/img/',
	claroMusicaPath: {
		artist: "https://www.claromusica.com/artist/",
		album: "https://www.claromusica.com/album/",
	},
	rbtPath: {
		phonogram: "http://www.clarosomdechamada.com.br/tone-detail/"
	},

	mainMenu: [
		'winners',
		'regulation',
		'help',
		'tickets',
		'game'
	],

	mainMenuFooter: [
		'home',
		'game',
		'tickets',
		'winners',
		'regulation',
		'help',
		'privacyPortal',
		'privacyPolicy'
	],

	routes: {
		home: 'home',
		regulation: 'regulation',
		winners: 'winners',
		help: 'help',
		tickets: 'tickets',
		game: 'game',
		error: 'error',
		privacyPortal: 'https://www.claro.com.br/privacidade',
		privacyPolicy: 'https://www.claro.com.br/privacidade/politica-de-privacidade'
	},

	headersEnrichment: [
		'msisdn',
		'x-up-calling-line-id',
		'x-up-subno',
		'x-nokia-msisdn'
	],

	ticketOrigins: [
		'CLARO_MUSICA_SUBSCRIPTION',
		'RBT_SUBSCRIPTION',
		'JM'
	],
};




// WEBPACK FOOTER //
// ../config/application.js